import Vue from "vue";
const vm = new Vue();

export const getReportInvoice = async (search) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .get( vm.$API_URL + "/admin/invoice", {
            headers: {
                Token: localStorage.getItem("access_token")
            },
            params: {
                date_start: search.date.startDate,
                date_end: search.date.endDate,
                invoice_no: search.invoiceNo,
                receipt_no: search.receiptNo,
                status: search.status,
                shop_code: search.shopCode,
                sa_code: search.saCode,
                payment_type: search.paymentType,
                page: search.page,
                per_page: search.perPage,
                ...( search.type ) ? { type: search.type } : {}
            }
        })
        .then((res) => {
            let data = res.data.data;
            if (!res.data.status) {   
                reject(res.data.error);
            }
            resolve(data);
        });
    });
};

export const payInvoice = async (invoiceId , isWht) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .post( vm.$API_URL + `/shop/payInvoice/${invoiceId}`, 
        {
            is_wht: isWht
        },
        {
            headers: {
                Token: localStorage.getItem("access_token")
            },
        })
        .then((res) => {
            if (!res.data.status) {   
                
                reject(res.data.error);
            }
            resolve(res.data)
        });
    });
};

export const getPDFReportInvoiceAndReceipt = async (invoiceId , type ) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .get( vm.$API_URL + `/admin/invoice/${invoiceId}/pdf`, {
            headers: {
                Token: localStorage.getItem("access_token")
            },
            params:{
                type: type
            }
        })
        .then( async (res) => {
            if(res.data.type === "application/json"){
                const error = JSON.parse(await res.data.text());
                if(!error.status){
                    reject(error.error.msg)
                }
            }else if (!res.data.status) {   
                reject(res.data.error);
            }else{
                resolve(res.data)
            }
        }).catch((error) => {
            reject(error);
        });
    });
};

export const getReportInvoiceForExcel = async ( search ) => {
    return new Promise((resolve) => {
        let ExcelTask = []
        let page = 1;
        for( let i = 0 ; i < search.totalPage; i++ ){
            ExcelTask.push( vm.$http
                .get(
                    vm.$API_URL + "/admin/invoice",
                    {
                        headers: {
                            Token: localStorage.getItem("access_token"),
                        },
                        params: {
                            date_start: search.date.startDate,
                            date_end: search.date.endDate,
                            invoice_no: search.invoiceNo,
                            receipt_no: search.receiptNo,
                            status: search.status,
                            shop_code: search.shopCode,
                            sa_code: search.saCode,
                            page: page++
                        }
                    }
                )
            ) 
        }
        Promise.all(ExcelTask).then( (resData) => {
            let dataExcel = [];
            resData.forEach( data => {
                dataExcel.push(...data.data.data.item)
            })  
            resolve(dataExcel)
        })
    })
}

export const updateStatueInvoice = async (invoiceId , status, isWht, datePaid) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .put( vm.$API_URL + `/admin/invoice/${invoiceId}/status`, 
        {
            status: status,
            is_wht: isWht,
            paid_at: datePaid
        },
        {
            headers: {
                Token: localStorage.getItem("access_token")
            },
        })
        .then((res) => {
            if (!res.data.status) {   
                
                reject(res.data.error);
            }
            resolve(res.data)
        });
    });
};

export const getReportInvoiceS3 = async (invoiceId) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .get( vm.$API_URL + `/admin/invoice/${invoiceId}/exportS3`, {
            headers: {
                Token: localStorage.getItem("access_token")
            },
        })
        .then( async (res) => {
            if (!res.data.status) {   
                reject(res.data.error);
            }
            resolve(res.data);
        }).catch((error) => {
            reject(error);
        });
    });
};

export const waiveInvoice = async (trackingCode) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .post( vm.$API_URL + `/shippop/cancel/order/invoice`, 
        {
            tracking_codes: trackingCode
        },
        {
            headers: {
                Token: localStorage.getItem("access_token")
            },
        })
        .then((res) => {
            if (!res.data.status) {   
                reject(res.data.error);
            }
            resolve(res.data.data)
        });
    });
};
